import React, { ReactNode, forwardRef, Ref } from 'react';
import { t } from 'ttag';
import { Typography } from 'antd';

const { Text } = Typography;

type Props = {
  children: ReactNode;
  /* eslint-disable react/require-default-props */
  isRequired?: boolean;
  disabled?: boolean;
  info?: ReactNode;
  /* eslint-enable react/require-default-props */
};

// forwardRef so antd's FormItem Tooltip/Trigger can attach a ref to the
// label's outer element — without this, antd emits
// "Function components cannot be given refs ... Check the render method of
// `Trigger`" when the form item has a `tooltip` slot.
const Label = forwardRef<HTMLSpanElement, Props>(
  ({ children, isRequired = false, disabled = false, info = null }, ref: Ref<HTMLSpanElement>) => (
    <span ref={ref} style={{ display: 'block' }}>
      <span style={{ display: 'flex', gap: 5 }}>
        <Text disabled={disabled} strong>
          {children}
        </Text>
        {isRequired && <Text type="secondary">{`(${t`required`})`}</Text>}
      </span>
      {info && <Text type="secondary">{info}</Text>}
    </span>
  ),
);
Label.displayName = 'Label';

export default Label;
